import { Box, Link, Typography } from "@mui/material";
import { rem } from "polished";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { ChipTicketStatus } from "src/components";
import {
  ariaLabel,
  PropertyLabels,
  TicketCategory,
  TicketHeadingCategory,
  TICKETS_PAGE,
} from "src/constants";
import { TicketFragment } from "src/graphql/generated/types";
import { useDeviceWidth } from "src/hooks";

import {
  headerStyle,
  subHeaderStyle,
  categoryStyle,
  categoryContainer,
  titleStyle,
  buildingInfoContainer,
  titleContainer,
  titleLinkStyle,
  ArrowBackIcon,
} from "./styles";

type Props = Pick<TicketFragment, "ticketNumber" | "status" | "building" | "unit" | "category">;

export const TicketInfoSection = ({ ticketNumber, status, building, category, unit }: Props) => {
  const { label, headingCategory } = TicketCategory[category];
  const { isMobile } = useDeviceWidth();

  return (
    <Box sx={{ p: isMobile ? 0 : 4 }}>
      <Box sx={headerStyle}>
        <Box sx={titleContainer}>
          <Link
            component={RouterLink}
            variant={!isMobile ? "h6" : undefined}
            sx={{ ...titleLinkStyle, fontSize: rem(20) }}
            underline="none"
            to={`../../${TICKETS_PAGE}`}
            aria-label={ariaLabel.ticketsLinkLabel}
          >
            {isMobile ? <ArrowBackIcon /> : "Mes demandes"}
          </Link>
          <Typography
            sx={{ ...titleStyle, fontSize: rem(20), lineHeight: 1.6 }}
            variant="h6"
            data-testid="ticketNumber"
          >
            {!isMobile && "/ "}Demande {ticketNumber}
          </Typography>
        </Box>
        {!isMobile && <ChipTicketStatus status={status} />}
      </Box>

      <Box sx={subHeaderStyle}>
        <Box sx={{ ...categoryContainer, flexDirection: isMobile ? "column" : undefined }}>
          <Typography
            sx={{ ...categoryStyle, fontWeight: "bold", fontSize: rem(16), lineHeight: 1.75 }}
          >
            Objet de la demande :
          </Typography>
          <Typography sx={{ ...categoryStyle, ml: 1 }}>
            {headingCategory && TicketHeadingCategory[headingCategory].label}
            {headingCategory && label && " / "}
            {label && label}
          </Typography>
        </Box>

        <Box sx={buildingInfoContainer}>
          <Typography>
            Immeuble {building?.number} - {building?.address.address1},{" "}
            {[building?.address.zipCode, building?.address.city].filter(Boolean).join(" ")}
          </Typography>
          {unit && (
            <Typography>
              {[
                unit.number,
                unit.description.entityType
                  ? PropertyLabels[unit.description.entityType]
                  : undefined,
                unit.situation.floor,
              ]
                .filter(Boolean)
                .join(" / ")}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
